import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  // When the bound element is inserted into the DOM...
  bind: function (el, binding) {
    // Focus the element
    // console.log('binding', binding)
    el.ontouchend = (event) => {
      eventBus.$emit('refresh-token-via-websockets')
      event.preventDefault()
      event.stopPropagation()
      binding.value()
    }
    el.onclick = (event) => {
      eventBus.$emit('refresh-token-via-websockets')
      binding.value()
    }
  }
}
